(function () {
  if (window.GiftBundleCheckoutGuardInitialized) return;
  window.GiftBundleCheckoutGuardInitialized = true;

  const FIELD_SELECTOR =
    '[data-gift-bundle-car-number], #car-number-drawer, #car-number, input[name="attributes[Car Number]"]';

  const CHECKOUT_TRIGGER_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#CartDrawer-Checkout',
    '#checkout',
    '.cart__checkout-button',
    'a[href*="/checkout"]'
  ].join(',');

  /*
    Important:
    Do NOT use form[action*="/cart"] here.
    Product add-to-cart forms can submit to /cart/add, especially on mobile.
    The guard must only control cart checkout forms, not product add-to-cart forms.
  */
  const CART_FORM_SELECTOR = [
    'form#cart',
    'form#CartDrawer-Form'
  ].join(',');

  const ERROR_CLASS = 'gift-bundle-car-number--error';

  let isProcessingCheckout = false;
  let bypassUntil = 0;
  let lastSavedValue = null;
  let saveTimer = null;

  injectStyles();
  bindEvents();

  function injectStyles() {
    if (document.getElementById('gift-bundle-checkout-guard-styles')) return;

    const style = document.createElement('style');
    style.id = 'gift-bundle-checkout-guard-styles';
    style.textContent = `
      .${ERROR_CLASS} {
        border-color: #d72c2c !important;
        outline: 2px solid #d72c2c !important;
      }

      .gift-bundle-car-number-error {
        display: block;
        color: #d72c2c;
        margin: 6px 0 0;
        font-size: 13px;
        line-height: 1.4;
      }

      .gift-bundle-car-number-error[hidden] {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  function bindEvents() {
    const captureOptions = { capture: true, passive: false };

    window.addEventListener('pointerdown', handleCheckoutAttempt, captureOptions);
    window.addEventListener('touchstart', handleCheckoutAttempt, captureOptions);
    window.addEventListener('click', handleCheckoutAttempt, captureOptions);
    window.addEventListener('submit', handleCheckoutAttempt, true);

    document.addEventListener(
      'input',
      function (event) {
        const input = getInputFromTarget(event.target);
        if (!input) return;

        if (input.value.trim()) {
          clearFieldError(input);
          scheduleBackgroundSave(input.value.trim());
        }
      },
      true
    );
  }

  function handleCheckoutAttempt(event) {
    if (shouldBypassGuard()) return;

    const attempt = getCheckoutAttempt(event);
    if (!attempt) return;

    const input = getActiveCarNumberField(attempt.trigger || attempt.form);
    if (!input) return;

    const value = input.value.trim();

    blockEvent(event);

    if (!value) {
      showFieldError(input);
      return;
    }

    clearFieldError(input);

    if (isProcessingCheckout) return;
    isProcessingCheckout = true;

    saveCartAttribute(value)
      .then(function () {
        bypassUntil = Date.now() + 1800;
        replayCheckout(attempt);
      })
      .catch(function () {
        showFieldError(input, getSaveErrorText());
      })
      .finally(function () {
        setTimeout(function () {
          isProcessingCheckout = false;
        }, 1200);
      });
  }

  function getCheckoutAttempt(event) {
    const target = getElementTarget(event);

    if (event.type === 'submit') {
      const form = target;

      if (!(form instanceof HTMLFormElement)) return null;
      if (!form.matches(CART_FORM_SELECTOR)) return null;

      const submitter =
        event.submitter ||
        (document.activeElement instanceof Element
          ? document.activeElement.closest(CHECKOUT_TRIGGER_SELECTOR)
          : null);

      if (!submitter || !submitter.matches(CHECKOUT_TRIGGER_SELECTOR)) {
        return null;
      }

      return {
        type: 'submit',
        form: form,
        trigger: submitter
      };
    }

    if (!target) return null;

    const trigger = target.closest(CHECKOUT_TRIGGER_SELECTOR);
    if (!trigger) return null;

    const form =
      trigger.form ||
      trigger.closest('form') ||
      document.querySelector('form#cart') ||
      document.querySelector('form#CartDrawer-Form');

    return {
      type: event.type,
      trigger: trigger,
      form: form || null
    };
  }

  function getActiveCarNumberField(contextElement) {
    const fields = Array.from(document.querySelectorAll(FIELD_SELECTOR)).filter(function (field) {
      return field instanceof HTMLInputElement && !field.disabled;
    });

    if (!fields.length) return null;

    const contextContainer =
      contextElement instanceof Element
        ? contextElement.closest(
            'cart-drawer, #main-cart-footer, form#cart, form#CartDrawer-Form, .drawer__footer, .cart__footer'
          )
        : null;

    if (contextContainer) {
      const contextField = fields.find(function (field) {
        return contextContainer.contains(field) && isVisible(field);
      });

      if (contextField) return contextField;
    }

    const activeDrawer = document.querySelector('cart-drawer.active');
    if (activeDrawer) {
      const drawerField = fields.find(function (field) {
        return activeDrawer.contains(field) && isVisible(field);
      });

      if (drawerField) return drawerField;
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      const cartPageField = fields.find(function (field) {
        return mainCartFooter.contains(field) && isVisible(field);
      });

      if (cartPageField) return cartPageField;
    }

    return fields.find(isVisible) || fields[0];
  }

  function getInputFromTarget(target) {
    const element = target instanceof Element ? target : null;
    if (!element) return null;

    if (element.matches(FIELD_SELECTOR)) return element;

    return null;
  }

  function isVisible(element) {
    if (!(element instanceof Element)) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = element.getBoundingClientRect();
    return !!(rect.width || rect.height || element.getClientRects().length);
  }

  function showFieldError(input, customMessage) {
    const message = customMessage || getRequiredErrorText(input);
    const errorElement = getOrCreateErrorElement(input);

    input.classList.add(ERROR_CLASS);
    input.setAttribute('aria-invalid', 'true');

    if (errorElement) {
      errorElement.textContent = message;
      errorElement.hidden = false;

      if (errorElement.id) {
        input.setAttribute('aria-describedby', errorElement.id);
      }
    }

    try {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      input.scrollIntoView();
    }

    setTimeout(function () {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
    }, 150);
  }

  function clearFieldError(input) {
    const errorElement = findErrorElement(input);

    input.classList.remove(ERROR_CLASS);
    input.removeAttribute('aria-invalid');

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }
  }

  function getOrCreateErrorElement(input) {
    let errorElement = findErrorElement(input);

    if (errorElement) return errorElement;

    errorElement = document.createElement('p');
    errorElement.className = 'gift-bundle-car-number-error';
    errorElement.setAttribute('data-gift-bundle-error-message', '');
    errorElement.hidden = true;

    if (input.id) {
      errorElement.id = `${input.id}-error`;
    }

    input.insertAdjacentElement('afterend', errorElement);
    return errorElement;
  }

  function findErrorElement(input) {
    const wrapper = input.closest('[data-gift-bundle-required-field], .cart-attribute__field');

    if (wrapper) {
      const errorInWrapper = wrapper.querySelector('[data-gift-bundle-error-message]');
      if (errorInWrapper) return errorInWrapper;
    }

    const next = input.nextElementSibling;
    if (next && next.matches('[data-gift-bundle-error-message], .gift-bundle-car-number-error')) {
      return next;
    }

    return null;
  }

  function getRequiredErrorText(input) {
    if (input.dataset.giftBundleError) return input.dataset.giftBundleError;

    const lang = (document.documentElement.lang || '').toLowerCase();

    if (lang.includes('pl')) return 'Proszę podać numer rejestracyjny';
    if (lang.includes('en')) return 'Please enter a license plate number';

    return 'Будь ласка введіть номерний знак';
  }

  function getSaveErrorText() {
    const lang = (document.documentElement.lang || '').toLowerCase();

    if (lang.includes('pl')) return 'Nie udało się zapisać numeru. Spróbuj ponownie.';
    if (lang.includes('en')) return 'Could not save the license plate number. Please try again.';

    return 'Не вдалося зберегти номер. Спробуйте ще раз.';
  }

  function scheduleBackgroundSave(value) {
    clearTimeout(saveTimer);

    saveTimer = setTimeout(function () {
      saveCartAttribute(value).catch(function () {
        // Silent background fail. Checkout attempt will try again and show an error if needed.
      });
    }, 700);
  }

  function saveCartAttribute(value) {
    const cleanValue = value.trim();

    if (lastSavedValue === cleanValue) {
      return Promise.resolve();
    }

    const updateUrl =
      window.routes && window.routes.cart_update_url
        ? window.routes.cart_update_url
        : '/cart/update.js';

    return fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Car Number': cleanValue
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart attribute save failed');
      }

      lastSavedValue = cleanValue;
      return response.json();
    });
  }

  function replayCheckout(attempt) {
    if (attempt.trigger && typeof attempt.trigger.click === 'function') {
      attempt.trigger.click();
      return;
    }

    if (!attempt.form) return;

    const checkoutButton = attempt.form.querySelector(CHECKOUT_TRIGGER_SELECTOR);

    if (checkoutButton && typeof checkoutButton.click === 'function') {
      checkoutButton.click();
      return;
    }

    if (typeof attempt.form.requestSubmit === 'function') {
      attempt.form.requestSubmit();
      return;
    }

    attempt.form.submit();
  }

  function shouldBypassGuard() {
    return Date.now() < bypassUntil;
  }

  function blockEvent(event) {
    if (!event) return;

    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function getElementTarget(event) {
    const target = event && event.target;

    if (target instanceof Element) return target;
    if (target && target.parentElement instanceof Element) return target.parentElement;

    return null;
  }
})();